import StepperContentContainer from "../StepperContentContainer"
import { Grid } from "@mui/system"
import { useContext } from "react"
import { KickOffContext } from "@/Contexts/KickOff"
import { User } from "@/graphql/generated/graphql"
import KickOffPdfView from "../../KickOffPdfView"
import EmailsList from "./EmailsList"

const ReviewAndSend: React.FC = () => {
  const {
    kickOffTitle,
    kickoffData,
    managers,
    activities,
    addresses,
    projectSettings,
    noteSections,
    setGeneratedPDF
  } = useContext(KickOffContext);

  return (
    <StepperContentContainer>
      <Grid container size={12} spacing={2}>
        <Grid size={9}>
          <KickOffPdfView
            kickOffTitle={kickOffTitle}
            initiator={kickoffData?.initiator as User}
            managers={managers}
            activities={activities}
            addresses={addresses}
            projectSettings={projectSettings}
            noteSections={noteSections}
            setGeneratedPDF={setGeneratedPDF}
          />
        </Grid>
        <Grid size={3}>
          <EmailsList />
        </Grid>
      </Grid>
    </StepperContentContainer>
  )
}

export default ReviewAndSend;
